class ProductTabs extends HTMLElement {
    constructor() {
      super();

      this.productTabs = this.querySelector('.product__tabs');
    }
  
    connectedCallback() {
        if (this.productTabs) {
            const tabTitles = this.productTabs.querySelectorAll('.product__tabs-name');
            const tabTexts = this.productTabs.querySelectorAll('.product__tabs-text');
            
            window.addEventListener('DOMContentLoaded', () => {
                tabTitles[0].classList.add('active');
                tabTexts[0].classList.add('active')
            });
        
            tabTitles.forEach((title) => title.addEventListener('click', () => {
                tabTitles.forEach((i) => i.classList.remove('active'));
                tabTexts.forEach((i) => i.classList.remove('active'));
                let i = [...title.parentElement.children].indexOf(title);
                title.classList.add('active');
                tabTexts[i].classList.add('active')
            }));
        }
    }
  }
  customElements.define('product-tabs', ProductTabs);